import React, { Component, createElement } from 'react';
import { ComponentsManager } from '@comall-backend-builder/core';

interface CategoryEditTabsProps {
    params: any;
    componentId: string;
}

export class CategoryEditTabs extends Component<CategoryEditTabsProps> {
    render() {
        const { componentId, params } = this.props;
        const items = [
            {
                title: '展示分类',
                content: {
                    component:
                        Number(params.level) === 2
                            ? 'categorySecondBaseInfoForm'
                            : 'categoryEditBaseInfoForm',
                },
            },
        ];

        if (params.level > 2) {
            items.push({
                title: '关联商品',
                content: {
                    component: 'CategoryUnionProductTableWrapper',
                },
            });
        }
        items.push({
            title: '筛选属性',
            content: {
                component: 'CategoryFilterAttrTableWrapper',
            },
        });

        const tabsProps = {
            componentId,
            params,
            cache: false,
            items,
        };
        return createElement(ComponentsManager.get('Tabs'), tabsProps);
    }
}
